import { createContext } from 'react'
const LanguageContext = createContext('de')
export default LanguageContext
